export default __webpack_public_path__ + "static/media/hand-pointing-right.f31ba71b.svg";